/**
 * @generated SignedSource<<28746ed772f4b53e841fb0e3d17e1c99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type eventosMonthTimeline_events$data = {
  readonly events: ReadonlyArray<{
    readonly id: string;
    readonly startDate: any;
    readonly " $fragmentSpreads": FragmentRefs<"eventCard">;
  }>;
  readonly " $fragmentType": "eventosMonthTimeline_events";
};
export type eventosMonthTimeline_events$key = {
  readonly " $data"?: eventosMonthTimeline_events$data;
  readonly " $fragmentSpreads": FragmentRefs<"eventosMonthTimeline_events">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "eventosMonthTimeline_events",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "events",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "eventCard"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MonthEvents",
  "abstractKey": null
};

(node as any).hash = "a6833ec21f92e7fe740e72ccf8a26fe7";

export default node;
